/** @jsx React.DOM */
'use strict';

var React = require('react'),
    Container = require('./Container');

var DustbinSimple = React.createClass({displayName: 'DustbinSimple',
  render:function() {
    return (
      React.createElement("div", null, 
        React.createElement(Container, null), 
        React.createElement("hr", null), 
        React.createElement("p", null
        )
      )
    );
  }
});

module.exports = DustbinSimple;


/*****************
 ** WEBPACK FOOTER
 ** ./_sortable-simple/index.js
 ** module id = 150
 ** module chunks = 0
 **/